import wpOcService from './wp-oc-service'

const menuService = {}

menuService.topMenu = function () {
    return wpOcService.get('menu/v1/top', {
        params: {}
    })
    .then(res =>  res.data)
}

export default menuService


// WEBPACK FOOTER //
// ./src/ws/menu.js